import React from 'react';
import {SubmissionStatus} from '../../scaffold';
import {Tag} from 'antd';

export default function SubmissionStatusTag(props: {status: SubmissionStatus}) {
  let color = 'blue';
  if ([SubmissionStatus.待导师审核, SubmissionStatus.待盲审审批, SubmissionStatus.待督导审批].includes(props.status)) color = 'orange';
  if ([SubmissionStatus.待分配督导, SubmissionStatus.待分配盲审].includes(props.status)) color = 'purple';
  if ([SubmissionStatus.督导审批不通过, SubmissionStatus.盲审审批不通过, SubmissionStatus.论文初审不通过].includes(props.status)) color = 'red';
  if ([SubmissionStatus.申请完成].includes(props.status)) color = 'green';
  return <Tag color={color}>{SubmissionStatus[props.status]}</Tag>;
}
